/**
 * Determines whether a `#RRGGBB` color is perceptually dark, so a contrasting
 * (light) text color should be used on top of it.
 */
export const isColorDark = (hexColor: string): boolean => {
  const red = parseInt(hexColor.substring(1, 3), 16);
  const green = parseInt(hexColor.substring(3, 5), 16);
  const blue = parseInt(hexColor.substring(5, 7), 16);
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance < 0.55;
};
